import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { AudioVersion } from '@core/api/entities/audioVersion'
import { AudioVersionMapper } from '@core/api/mappers/audioVersionMapper'
import { audioVersionService } from '@core/api/services/audioVersionService'

import { DEFAULT_PARAMS } from './common'

/**
 * Get all audio versions
 */
export const useAudioVersions = ({
	config,
	options,
}: any = DEFAULT_PARAMS): UseQueryResult<AudioVersion[], Error> => {
	const QUERY_KEY = ['audio-versions']

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			audioVersionService
				.getAudioVersions(config)
				.then(({ data: response }) => {
					return AudioVersionMapper.toEntities(response.data)
				}),
		staleTime: 5 * 60 * 1000,
		...options,
	})
}
